import {FC,} from "react";
import {Route} from "react-router-dom";
import {Navigate, Routes} from "react-router";
import {MembersWithdrawListPage} from "./List";
import {MembersWithdrawDetailPage} from "backoffice/ui/Pages/Members/Withdraw/Detail";

export const MembersWithdrawPage: FC = () => {
  return (
      <Routes>
        <Route index element={<MembersWithdrawListPage/>}/>
        <Route path=":id" element={<MembersWithdrawDetailPage/>}/>
        <Route path="*" element={<Navigate to="/" replace/>}/>
      </Routes>
  );
}


